import React from 'react';

export default () => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L6.00022 6L11 1.00043" stroke="black" />
  </svg>
);
